










































































































































































































































































































































































import Vue from "vue";

export default Vue.extend({
  name: "SocialsizeControl.vue",
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
  }),
});
